import { Space, Typography } from 'antd';

export function SpTextGround({ color = '#fff', children, circle = false, size = 10, typographyStyle = null }) {
  return (
    <Space size={5} align="center">
      <div style={{ width: size, height: size, backgroundColor: color, borderRadius: circle ? '50%' : 3 }}></div>
      <Typography.Text style={{ ...typographyStyle, color }}>{children}</Typography.Text>
    </Space>
  );
}
